module.exports = __webpack_public_path__ + "static/media/Partner-LogosCommon-Grounds.53086dfd.png";